import { render, staticRenderFns } from "./RegistrationProgress.vue?vue&type=template&id=0a59e0f3&"
import script from "./RegistrationProgress.vue?vue&type=script&lang=js&"
export * from "./RegistrationProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports